/**
 * Client-side permission helpers. localStorage PERMISSIONS holds permission NAMES
 * (comma-separated strings from login), not numeric permission IDs.
 */
export const normalizePermissions = (permissionsInput) => {
  const rawPermissions = Array.isArray(permissionsInput)
    ? permissionsInput
    : String(permissionsInput || "").split(",");

  return rawPermissions
    .map((permission) => String(permission || "").trim())
    .filter(Boolean);
};

export const getStoredPermissions = () =>
  normalizePermissions(localStorage.getItem("PERMISSIONS"));

export const savePermissions = (permissionsInput) => {
  const normalizedPermissions = normalizePermissions(permissionsInput);
  localStorage.setItem("PERMISSIONS", normalizedPermissions.join(","));
  return normalizedPermissions;
};

export const hasPermission = (permissionName, permissionsInput) => {
  const normalizedPermissions = normalizePermissions(permissionsInput);
  return normalizedPermissions.includes(String(permissionName || "").trim());
};
